<template>
  <div class="d-flex align-center">
    <v-btn
      v-if="!($route.name === 'commissioner' && currentStep === 2)"
      round
      outline
      color="primary"
      style="max-width: 103px"
      :style="$route.name === 'totem' ? 'height: 45px !important' : ''"
      depressed
      class="normal-text ml-0"
      @click="backAStep"
    >
      Voltar
    </v-btn>
    <div class="btn-next-step">
      <v-btn
        block
        depressed
        id="next-step-button"
        round
        :style="$route.name === 'totem' ? 'height: 45px !important' : ''"
        class="normal-text"
        :class="{ 'btn-disabled': !enabled }"
        :color="enabled ? 'primary' : 'info'"
        dark
        :loading="loading"
        @click="nextStep"
        >Continuar</v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ['enabled', 'actionBeforeNextStep', 'resetPaymentOptions'],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    currentStep() {
      return this.$store.getters.currentStep;
    },
  },
  methods: {
    async nextStep() {
      this.loading = true;
      if (this.resetPaymentOptions) {
        console.log('setPurchaseStarted - nextStep - false');
        this.$store.dispatch('setPurchaseStarted', false);
      }
      if (this.enabled) {
        try {
          if (this.actionBeforeNextStep) {
            await this.$store.dispatch(
              `${this.actionBeforeNextStep.action}`,
              this.actionBeforeNextStep.payload
            );
          } else
            this.$store.dispatch(
              'nextStep',
              `nextStepButton - action: ${
                this.actionBeforeNextStep
                  ? this.actionBeforeNextStep.action
                  : 'none'
              }`
            );
        } catch (e) {
          this.$store.dispatch('openSnackbar', {
            message:
              e && e.response && e.response.data && e.response.data.message
                ? e.response.data.message
                : 'Erro ao nomear ingressos.',
          });
          this.loading = false;
        }
      }
      if (this.$route.name === 'commissioner')
        return this.$store.dispatch('setCurrentStep', 4);
      if (this.currentStep === 3 && this.$route.name === 'totem')
        this.$store.dispatch('nextStep');
      this.loading = false;
    },
    backAStep() {
      if (this.resetPaymentOptions) {
        console.log('setPurchaseStarted - backAStep - false');
        this.$store.dispatch('setPurchaseStarted', false);
      }
      this.$store.dispatch('backAStep');
      if (this.currentStep === 3 && this.$route.name === 'totem')
        this.$store.dispatch('backAStep');
    },
  },
};
</script>
